import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Constant } from 'src/app/constants/constant';
import { Product } from 'src/app/models/app.models';
import { environment } from 'src/environments/environment';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReviewRatingService } from 'src/app/services/review-rating.service';
import { OutOfStockService } from 'src/app/services/out-of-stock.service';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';
import { CommonSignInComponent } from 'src/app/shared/CommonSignIn/CommonSignIn.component';
import { AboutService } from 'src/app/services/about.service';
import { CommonService } from 'src/app/services/common.service';
import { downloads } from '../../util/calsoft-validators';
import { ProductService } from 'src/app/services/product.service';
import { SpecificationService } from 'src/app/services/specification.service';
import { RestrictionComponent } from 'src/app/shared/restriction/restriction.component';
import { Location } from '@angular/common';
import { AnalyticService } from 'src/app/services/analytic-service';

@Component({
  selector: 'calsoft-product-type14',
  templateUrl: './product-type14.component.html',
  styleUrls: ['./product-type14.component.scss']
})
export class ProductType14Component implements OnInit {


  public youtubeUrl = environment.youtubeUrl;

  @Input() selection: any = [];
  
  @Input() productDetailPage: any;

  @Input() productCustomOption: any;

  @Input() data: any;

  @Input() name: any;

  @Input() response: any;

  @Input() reviewDetail: any

  @Input() relatedProductsList: any;

  @Input() upSellsProductsList: any;

  @Input() crossSellsProductsList: any

  @Input() recentlyViewedProducts: any;

  @Input() displayColdChain: boolean;
  @Input() deliveryDoorStepIcon: any;
  @Input() showTimeIcon: any;
  @Input() showGenuineProductIcon: any;
  @Input() genuineProductText: any;
  @Input() deliveryTime: any;
  @Input() deliveryDoorStepText: any;
  @Input() ColdChain: any;
  @Input() product: any;
  @Input() guestLogin: any;
  @Input() videourl: any;
  @Input() videoAvaliable: boolean;
  @Input() isInStock: any;
  @Input() qty: any;
  @Input() manageStock: any;
  @Input() factBox: any;
  @Input() faq: any;
  @Input() SIDEEFFECTS: any;
  @Input() Commonsideeffects: any;
  @Input() SafetyAdvice: any;
  @Input() HOWTOUSE: any;
  @Input() UsesOf: any;
  @Input() Benefits: any;
  @Input() HowWorks: any;
  @Input() Ifmiss: any;
  @Input() productName: any;
  @Input() PregnancyInteraction: any;
  @Input() BreastfeedingInteraction: any;
  @Input() DrivingInteraction: any;
  @Input() KidneyInteraction: any;
  @Input() LiverInteraction: any;
  @Input() MANUFACTURER: any;
  @Input() SALTCOMPOSITION: any;
  @Input() STORAGES: any;
  @Input() factbox: any;
  @Input() spec: any;
  @Input() showNewConfig: boolean = false;
  @Input() units: any;
  @Input() discountPercentage: any;
  @Input() price: number;
  @Input() specialPrice: any;
  @Input() averageRating: any;
  @Input() calculateAvgRating: any
  @Input() prescriptionRequired: boolean = false;
  @Input() imageList: any;
  @Input() productDetailImageWidth: any;
  @Input() productzoom: any;
  @Input() productIdAddedInCart: any = {};
  @Input() configattributeType: any;
  @Input() firstIndex: any;
  @Input() secondIndex: any;
  @Input() configurationDropDownList = new Map<any, any>();
  @Input() dropDownValue = new UntypedFormControl('');
  @Input() configProductSelected: any;
  @Input() configProduct: any;
  @Input() showExclusivePrice: number;
  @Input() managePriceSeperately: number;
  @Input() maintainStockIndConfProduct: number;
  @Input() manageAdditionalInformationSeperately: number;
  @Input() manageDescriptionSeperately: number;
  @Input() manageNameSeperately: number;
  @Input() description: any;
  @Input() manageImageSeperately: number;
  @Input() bigImage: string;
  @Input() alcoholInteraction: any;
  @Input() commonImageApi: any;
  @Input() relatedProductsText: any;
  @Input() upSellProductsText: any;
  @Input() crossSellProductsText: any;
  @Input() recentlyViewedProductsText: any;
  @Input() showCartIcon: any;
  @Input() showCartIncremented: any;
  @Input() categoryArray: any;
  @Input() indexConfig: any = 0;
  @Input() productImageWidth: any;
  @Input() productImageType: any;
  @Input() productImageWidthMob: any;
  @Input() productImageHeightMob: any;
  @Input() productImageHeight: any;
  @Input() showConfigurableDropdown: any;
  @Input() buttonArray: any = [];
  @Input() productDetailHeightMobile: any;
  @Input() productDetailWidthMobile: any;
  @Input() productDetailHeight: any;
  @Input() productDetailWidth: any;
  @Input() coversionTrackingIdGa: any;
  enableEnquire: any = 0;
  disablePriceInDetailPage: any = 1;
  @Input() sizeChartId: any;
  @Input() MapLink: any;
  @Input() shortDescription: any;

  @Input() CourceDescription: any;

  @Input() CourseIncludes: any;

  @Input() Language: any;

  @Input() LastUpdated: any;

  public serverPath7 = environment.commonImageApi + "catalog/product";



  @ViewChild('shareProduct') shareProduct: TemplateRef<any>;

  @ViewChild('zoomViewer', { static: true }) zoomViewer;

  @Input() image: any;
  @Input() zoomImage: any;
  @Input() sub: any;
  @Input() form: UntypedFormGroup;
  @Input() relatedProducts: Array<Product>;
  @Input() filterRequest: any;
  @Input() images: Object;
  @Input() query: any;
  @Input() documentId: any;
  @Input() configurableProductId: any;

  @Input()  courseDetailPageType:any = 0

  @Input() event: any;
  b2bPricingEnabled: string | number;
  initalArray: any[];
  Layout: any;
  @Input() public pageTitle: any
  @Input() public homePageBuilder: any;
  layoutype: any;
  init: boolean;
  courseText: any=[];
  videocontent: any;
  activeIndex: number = 0;
  videolist: any=[];
  type: any;
  specificationList: Object;

  @Input() encryptedProductName:any;

  public serverPathSpecification = environment.commonImageApi + '/specification/';

  public LecturerServerPath = environment.commonImageApi + '/lecturer/';

  form_validation_messages = {

    'phone': [
      { type: 'required', message: 'Please fill out this field.' },
      { type: 'minlength', message: 'Enter a Valid Number' },
      { type: 'maxlength', message: 'Enter a Valid Number' },
    ],

    }
  @Input() Lecture: any;

  LectureDetails: any;
  producImageWidth: any;
  popUpWidth: any ='790px';
  popUpHeight: any = '750px';

  constructor(
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private clipboard: Clipboard,
    private snackBar: MatSnackBar,
    public title: Title, public meta: Meta,
    private reviewService: ReviewRatingService,
    private outOfStockService: OutOfStockService,
    private dialog: MatDialog,
    private _formBuilder: FormBuilder,
    private userService: UserService,
    private aboutService: AboutService,
    private productService: ProductService,
    private specificationService : SpecificationService,
    private location: Location,
    public router: Router,
    private analyticService: AnalyticService,
  ) { }


  initShortDescription: boolean=false;

  ngOnInit() {

    if (this.product['courseText'] != null) {
 
      this.courseText =JSON.parse(this.product['courseText'])

      // this.courseText.forEach(obj => {
      //   obj.courseItem.forEach(item => {
      //     const matchlist = item.value.match(/\.[^/.]+$/);

      //     if (matchlist == '.mp4' && item.freePreview==1 ) {
      //       this.videolist.push(item);
      //     }
      //   });
      // });

    } 

    if(this.shortDescription!=undefined){

      if(this.shortDescription.length>0){
        this.shortDescription = this.shortDescription.replace(/<ul>/g, '')
        .replace(/<\/?li>/g, '')
        .replace(/<\/?p>/g, '')
        .replace(/<br>/g, '');

      }

      this.initShortDescription=true;
    
    }else{
      this.initShortDescription=false;
    }

    

    if (this.name == undefined) {
      this.name = '';
    }

    this.productIdAddedInCart = this.product;
    this.textAccount = 'OK';
    this.productName = this.name;

    this.initalArray = [];


    if (this.configProductSelected['isCustomizedValue'] != null) {
      if (this.configProductSelected['isCustomizedValue']['Layout'] != null) {
        this.Layout = this.configProductSelected['isCustomizedValue']['Layout'];

      }
    }

    
    this.pageTitle = this.Layout

    if (this.Layout != null) {
      this.getAboutData();
    }

    if(this.CourseIncludes?.length>0){
      this.getAllSpecification(this.CourseIncludes);
    }

    if(this.Lecture!=null){
      this.getLecturerById();
    }


    this.productImageHeight = this.data['productImageHeight'];

    this.producImageWidth = this.data['producImageWidth'];

    this.popUpHeight = this.data['popUpHeight'];

    this.popUpWidth = this.data['popUpWidth'];

  }


  getLecturerById() {
    this.specificationService.getLecturerById(this.Lecture)
      .subscribe(res => {
 
           this.LectureDetails = res;
   
           console.log(this.LectureDetails);
           
   
         },
         error => {
         }
       )
  }

  getAllSpecification(CourseIncludes:any) {
    this.specificationService.getSpecificationId(CourseIncludes).subscribe(
      res => {
  
     //   this.specificationList = res['content'];

        this.specificationList = res;

        console.log(this.specificationList);
        

      },
      error => {
      }
    )
  }


  getAboutData() {

    this.aboutService.getPageById(this.pageTitle).subscribe(
      (res) => {
        this.layoutype = res['type'];
        this.homePageBuilder = res['homePageBuilder'];
        this.init = true;

      }
    )
  }

  facebook() {
    let url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(location.href)
    'facebook-share-dialog'
    this.commonService.goToLink(url)

  }

  whatsapp() {
    let currentURL = window.location.href
    let encodedURL = encodeURIComponent(currentURL); // Encode the URL
    let url = `https://api.whatsapp.com/send?text=${encodedURL}`;
    this.analyticService.customEventEmitter('WA_button_Clicked', 'BUTTON_CLICK',
      'Whats App Click', url)
    this.commonService.goToLink(url)
  }



  generateWhatsAppMessage() {

    let message = `Hi, I'm interested in buying the ${this.product.name}.\n`;
    message += `Can you please provide more information about it, including the price?`;
    const url = `https://api.whatsapp.com/send?phone= ${encodeURIComponent(this.data.storePhoneNumber)}&text=${encodeURIComponent(message)}`;
    this.commonService.goToLink(url)
  }

  copy() {
    let currentURL = window.location.href
    this.clipboard.copy(`${currentURL}`);
    this.snackBar.open(`Copied `, '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
  }


  copyText() {
    let currentURL = window.location.href;
    const referralId = localStorage.getItem('referral-Id');
  
    if (referralId) {
      const url = new URL(currentURL);
      url.searchParams.set('refId', referralId);
      currentURL = url.toString();
    }
  
    this.clipboard.copy(currentURL);
    this.snackBar.open(`Copied`, '×', {
      panelClass: 'success',
      verticalPosition: 'bottom',
      duration: 3000
    });
  }
  

  public onMouseMove(e) {


    if (window.innerWidth >= 1280) {
      var image, offsetX, offsetY, x, y, zoomer;
      image = e.currentTarget;
      offsetX = e.offsetX;
      offsetY = e.offsetY;
      x = offsetX / image.offsetWidth * 100;
      y = offsetY / image.offsetHeight * 100;
      zoomer = this.zoomViewer.nativeElement.children[0];
      if (zoomer) {
        zoomer.style.backgroundPosition = x + '% ' + y + '%';
        zoomer.style.display = "block";
        zoomer.style.height = image.height + 'px';
        zoomer.style.width = image.width + 'px';
      }
    }
  }

  public onMouseLeave(event) {

    if (this.zoomViewer.nativeElement.children.length > 0) {
      this.zoomViewer.nativeElement.children[0].style.display = "none";
    }

  }

  getConfigProductIdNew(event, i, value, index) {
    if (event.isUserInput != false) {
      this[index] = i;
      this.configurableProductId = this.configurationDropDownList[this.firstIndex]
      ['recursuive'][this.secondIndex].productId;
      this.configProductSelected = JSON.parse(this.configProduct[this.configurableProductId]);
      this.setConfigProductItem();
    }
  }


  setConfigProductItem() {
    if (this.product['type'] == "Configurable") {
      this.getProductDetailReviewId(this.configurableProductId);
    }
    if (this.product['type'] == "Variants") {

      this.getProductDetailReviewIdAndSubId(this.configurableProductId, this.product.entityId);
    }
    if (this.showExclusivePrice == 1) {
      if (this.configurableProductId['isCustomizedValue'] != null) {
        if (this.configurableProductId['isCustomizedValue']
        ['specialPriceWithoutTaxamount'] != null) {
          this.specialPrice = this.configurableProductId['isCustomizedValue']
          ['specialPriceWithoutTaxamount'];
        }
        if (this.configurableProductId['isCustomizedValue']
        ['priceWithoutTaxamount'] != null) {
          this.price = this.configurableProductId['isCustomizedValue']
          ['priceWithoutTaxamount'];
        }
      }
    }
    if (this.managePriceSeperately == 1) {
      this.price = this.configProductSelected['price'];
      this.specialPrice = this.configProductSelected['specialPrice'];
      this.discountPercentage = this.configProductSelected['discountPercentage'];


      if (this.configProductSelected['isCustomizedValue'] != null) {
        this.b2bPricingEnabled = localStorage.getItem(Constant.B2B_USER) == null ? 0 : localStorage.getItem(Constant.B2B_USER);
        if (this.b2bPricingEnabled == 0) {
          this.price = this.configProductSelected['price'];
          this.specialPrice = this.configProductSelected['specialPrice'];
        } else {

          if (this.configProductSelected['isCustomizedValue']['Whole Sale Price'] != undefined) {


            this.price = this.configProductSelected['isCustomizedValue']['Whole Sale Price'];
            this.specialPrice = this.configProductSelected['isCustomizedValue']['Whole Sale Discount Price'];

            if (Number.isNaN(this.configProductSelected['isCustomizedValue']['Whole Sale Discount Percentage'])) {
              this.discountPercentage = 0.0;
            }

            else if (this.configProductSelected['isCustomizedValue']['Whole Sale Discount Percentage'] != null) {
              this.discountPercentage = parseFloat(this.configProductSelected['isCustomizedValue']['Whole Sale Discount Percentage']);
            } else {
              this.discountPercentage = 0.0;
            }
            if (this.price == 0.0) {
              this.price = this.configProductSelected['price']
              this.specialPrice = this.configProductSelected['specialPrice']
              this.discountPercentage = this.configProductSelected['discountPercentage']
            }
          }
        }
      }
    }

    if (this.maintainStockIndConfProduct == 1) {
      this.qty = this.configProductSelected['qty'];
      this.manageStock = this.configProductSelected['manageStock'];
      this.isInStock = this.configProductSelected['isInStock'];
      this.productIdAddedInCart = this.configProductSelected;
      this.averageRating = this.configProductSelected['averageRating'];
      this.calculateAvgRating = this.configProductSelected['calculateAvgRating'];

    }


    if (this.manageAdditionalInformationSeperately == 1) {
      this.spec = this.configProductSelected['additionalSpec'];
    }


    if (this.manageDescriptionSeperately == 1) {
      this.description = this.configProductSelected['description'];
    }

    if (this.manageNameSeperately == 1) {
      this.name = this.configProductSelected['name'];
    }

    if (this.manageImageSeperately == 1) {

      if (this.configProductSelected['productImageUrl'] != 'no_selection') {
        if (this.configProductSelected['productImageUrl'].includes('http')) {
          this.image = this.configProductSelected['productImageUrl'];
          this.zoomImage = this.configProductSelected['productImageUrl'];
        } else if (this.configProductSelected['productImageUrl'].includes("medicineimages")) {
          this.image = this.commonImageApi + this.configProductSelected['productImageUrl'];
          this.zoomImage = this.commonImageApi + "/" + this.configProductSelected['productImageUrl'];

        } else if (this.configProductSelected['productImageUrl'].includes("commonimages")) {
          this.image = this.serverPath7 + this.configProductSelected['productImageUrl'];
          this.zoomImage = this.serverPath7 + "/" + this.configProductSelected['productImageUrl'];
        }
        else {
          this.image = this.bigImage + "/" + this.configProductSelected['productImageUrl'];
          this.zoomImage = this.bigImage + "/" + this.configProductSelected['productImageUrl'];
        }
      } else {
        this.image = this.configProductSelected['productImageUrl'];
        this.zoomImage = this.configProductSelected['productImageUrl'];
      }

      this.imageList = this.configProductSelected['images'];

      if (this.imageList == null) {
        this.imageList = []
      }
      if (this.imageList[0] == undefined) {
        this.image = "assets/images/products/noImage/no-image.png";
        this.zoomImage = "assets/images/products/noImage/no-image.png";
      }

    }
  }

  getProductDetailReviewIdAndSubId(productId, subProductId) {
    this.reviewService.getProductDetailReviewVariant(productId, subProductId)
      .subscribe(
        data => {
          this.reviewDetail = data;
        },
        error => {
        }
      );
  }



  getProductDetailReviewId(productId) {
    this.reviewService.getProductDetailReviewAll(productId)
      .subscribe(
        data => {
          this.reviewDetail = data;
        },
        error => {
        }
      );
  }

  setZoomImage(event) {
    this.zoomImage = event

  }

  getConfigProductId(event, index) {

    this.firstIndex = index;
    //  let value = event.split("#")[0];
    if (event.includes(",")) {
      event = event.split(",")[0];
    }
    this.configurableProductId = event.split("#")[1];
    this.configProductSelected = JSON.parse(this.configProduct[this.configurableProductId]);
    this.dropDownValue.patchValue(event);
    this.setConfigProductItem();
  }

  getConfigProductIdButton(i, index) {

    this[index] = i;
    this.configurableProductId = this.configurationDropDownList[this.firstIndex]
    ['recursuive'][this.secondIndex].productId;
    this.configProductSelected = JSON.parse(this.configProduct[this.configurableProductId]);
    this.setConfigProductItem();

  }

  createNotify(object, url) {

    this.outOfStockService.outOfStockNotification(object, url).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });

        }
        else {

          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
      },
      (err) => { });

  }


  // notify

  @ViewChild('notify') notify: TemplateRef<any>;

  initOutStockFunction() {
    let authourized = this.userService.getAuthenticatedUser();
    let guestLoginEnabled = localStorage.getItem(Constant['GUEST_LOGIN'])
    if (guestLoginEnabled == "0" && authourized==null) {
      this.loginModel();
    }else if (guestLoginEnabled == "0" || authourized) {
      let object = {
        'productId': this.product['entityId'],
        'productName': this.name,
        'guest': 0,
      }
      let url = '/outofstocknotification/web';
      this.createNotify(object, url);
    } else {
      let dialogRef = this.dialog.open(this.notify, {
        width: '500px',
        disableClose: true,
      });
      dialogRef.disableClose = true;
    }

  }


  loginModel() {
		if (window.innerWidth > 768) {
	
		  let dialogRef = this.dialog.open(CommonSignInComponent, {
			width: '790px',
			data: { page: this.page1, }
		  });
	
		  dialogRef.disableClose = true;
		  dialogRef.afterClosed().subscribe(result => {
			this.ngOnInit();
	
	
		  });
	
		}
		else {
		  let dialogRef = this.dialog.open(CommonSignInComponent, {
			minWidth: '100vw', height: '100vh',
			data: { page: this.page1, }
		  });
	
		  dialogRef.disableClose = true;
		  dialogRef.afterClosed().subscribe(result => {
			this.ngOnInit();
	
	
		  });
		}
	
	  }
  showMore = false;

  instructor = {
    name: 'Colt Steele',
    title: 'Developer and Bootcamp Instructor',
    image: 'path/to/image.jpg',
    details: [
      { icon: 'star', text: '4.7 Instructor Rating' },
      { icon: 'comment', text: '530,239 Reviews' },
      { icon: 'people', text: '1,740,824 Students' },
      { icon: 'play_circle_filled', text: '30 Courses' }
    ],
    bio: `Hi! I'm Colt. I'm a developer with a serious love for teaching...
    I've spent the last few years teaching people to program at 2 different immersive bootcamps where I've helped hundreds of people become web developers and change their lives. My graduates work at companies like Google, Salesforce, and Square. Most recently, I led Galvanize's SF's 6 month immersive program as Lead Instructor and Curriculum Director. After graduating from my class, 94% of my students went on to receive full-time developer roles. I also worked at Udacity as a Senior Course Developer on the web development team where I got to reach thousands of students daily.

    I've since focused my time on bringing my classroom teaching experience to an online environment. In 2016 I launched my Web Developer Bootcamp course, which has since gone on to become one of the best selling and top rated courses on Udemy. I was also voted Udemy's Best New Instructor of 2016.

    I've spent years figuring out the "formula" to teaching technical skills in a classroom environment, and I'm really excited to finally share my expertise with you. I can confidently say that my online courses are without a doubt the most comprehensive ones on the market.
    
    Join me on this crazy adventure!`
  };

  toggleShowMore() {
    this.showMore = !this.showMore;
  }

  page1: any;

 
  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { whitespace: true };
    };
  }


  secondFormGroup = this._formBuilder.group({
    customerName: ['', [Validators.required, this.noWhitespaceValidator()]],    
      email: ['', [Validators.required, Validators.email]], 
    phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]] 
  });
  


  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }
  textAccount: string;


  submitOutOfStockPopup() {

    if (this.secondFormGroup.valid) {
      //  console.log(this.secondFormGroup);

      this.dialog.closeAll();
      let url = '/ig/outofstocknotification/web';

      let object = {
        'productId': this.product['entityId'],
        'productName': this.name,
        'customerName': this.secondFormGroup.value['customerName'],
        'customerEmail': this.secondFormGroup.value['email'],
        'customerPhoneNumber': this.secondFormGroup.value['phone'],
        'guest': 1,
        'customerId': 0
      }
      this.createNotify(object, url);

    }
    else {
      this.validateAllFormFields(this.secondFormGroup);
      this.secondFormGroup.reset();
    }

  }
  getImageproductIdOld(event) {

    let productId = event.split("#")[1];
    let value = JSON.parse(this.configProduct[productId]);

    if (value.productImageUrl.includes("http")) {
      return value.productImageUrl;

    }
    else if (value.productImageUrl.includes("medicineimages")) {
      return this.commonImageApi + value.productImageUrl;

    } else if (value.productImageUrl.includes("commonimages")) {
      return this.serverPath7 + value.productImageUrl;

    } else {
      return this.bigImage + "/" + value.productImageUrl;

    }

  }


  getImageproductId(productId) {

    let value = JSON.parse(this.configProduct[productId]);
    if (value.productImageUrl != undefined) {

      if (value.productImageUrl.includes("http")) {
        return value.productImageUrl;

      }
      else if (value.productImageUrl.includes("medicineimages")) {
        return this.commonImageApi + value.productImageUrl;

      } else if (value.productImageUrl.includes("commonimages")) {
        return this.serverPath7 + value.productImageUrl;

      } else {
        return this.bigImage + "/" + value.productImageUrl;

      }
    } else {
      return value.productImageUrl
    }



  }
  highlighted: number;

  public selectImage(image, i) {
    this.highlighted = i;
    this.image = this.bigImage + image;
    this.zoomImage = this.bigImage + image;

  }

  public selectImage1(image, i) {
    this.highlighted = i;
    this.image = this.commonImageApi + image;
    this.zoomImage = this.commonImageApi + image;


  }
  isExpanded : boolean = false;
  toggleContent() {
    this.isExpanded = !this.isExpanded;
  }

  getDirections(MapLink: string): void {
    if (MapLink && MapLink.toLowerCase() !== 'none') {
      let url = MapLink.toLowerCase();

      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = 'http://' + url;
      }

      this.commonService.goToLink(url)
    }

  }
  salesFlatQuoteItemOption: any = [];
  getSalesFlatQuoteItemOptiion(i) {
    this.salesFlatQuoteItemOption = i;

    console.log(this.salesFlatQuoteItemOption);

  }

  setValueForSalesItemOption(finalValue) {
    // if (finalValue.event == 'close') {
    //   let index = this.salesFlatQuoteItemOption.findIndex(x => x.code == finalValue.data);
    //   this.salesFlatQuoteItemOption.slice(0,index);
    // } else {

    let object = {
      productId: this.product['entityId'],
      code: finalValue.childKey,
      value: finalValue.value,
      additional: finalValue.additional,
      additionalInfoGiven: finalValue.additionalInfoGiven,
      materialCost: finalValue.materialCost,
      additionalCost: finalValue.additionalCost,
    }

    this.salesFlatQuoteItemOption.push(object);
    // }
  }

  customProductElament: any = [];
  customProductMap = new Map<any, any>();
  updateCheckedOptions(event, j, primaryIndex, secondaryIndex, secondaryId, final) {
    let entityId = this.customProductElament[primaryIndex].productCustomizationList[secondaryIndex]['entityId']
    let childKey = this.customProductElament[primaryIndex].productCustomizationList[secondaryIndex]['key']
    if (event.checked) {
      this.customProductMap.set(primaryIndex, secondaryId);
      let price = final;
    } else {
      this.customProductMap.delete(primaryIndex);
      let index = this.salesFlatQuoteItemOption.findIndex(x => x.code == childKey);
      this.salesFlatQuoteItemOption.splice(index, 1);
    }
  }

  accordionOpenIndex: number | null = 0;
  subaccordionOpenIndex: { [key: number]: number | null } = {};

  toggleAccordion(index: number) {
    if (this.accordionOpenIndex === index) {
      this.accordionOpenIndex = null; 
    } else {
      this.accordionOpenIndex = index;
    }
  }
  
  closeAccordion(event: Event) {
    event.stopPropagation();
    this.accordionOpenIndex = null;
  }

  subtoggleAccordion(parentIndex: number, subIndex: number) {
    if (this.subaccordionOpenIndex[parentIndex] === undefined) {
      this.subaccordionOpenIndex[parentIndex] = null;
    }
    this.subaccordionOpenIndex[parentIndex] = this.subaccordionOpenIndex[parentIndex] === subIndex ? null : subIndex;
  }


  @ViewChild('video') video: TemplateRef<any>;

  ViewVideo(event: any) {
    this.videocontent = event; 
    this.type= this.videocontent.type
    this.currentVideoUrl = this.videocontent.value;
    this.activeIndex = this.videocontent.title;

    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(this.video, {
        width: this.popUpWidth,
        height:this.popUpHeight

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
  
        
      });

    }
    else {
      let dialogRef = this.dialog.open(this.video, {
        minWidth: '100vw', height: '100vh',
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
   
      });
    }
	}

  

  closeModal(){
    this.dialog.closeAll();
  }

  productData = [
    {
      values: {
        short_description: null,
        featured: 0,
        MapLink: null,
        WholeSalePrice: 0.0,
        discountPrice: 0.0,
        description: "Angular js",
        units: 0,
        ScentType: "",
        Name: "Angular js",
        WholeSaleDiscountPrice: 0.0,
        price: 1200.0,
        supplier: null,
        sku: "Angular js",
        MaterialCost: 0.0,
        gallery: null,
        image: null,
        thumbnail: null,
        meta_title: null,
        visibility: 4,
        isCustomized: null,
        media_gallery: null,
        tax_class_id: 59,
        CustomProductResource: null,
        weight: 1000.0,
        meta_description: null,
        country_of_manufacture: null,
        special_price: 0.0,
        meta_keyword: null,
        product_seo_name: null,
        video_id: null
      },
      valueIds: {
        short_description: "1091408",
        featured: "436365",
        MapLink: "374299",
        WholeSalePrice: "214011",
        discountPrice: "214013",
        description: "1091407",
        units: "436369",
        ScentType: "",
        Name: "374296",
        WholeSaleDiscountPrice: "214012",
        price: "214009",
        supplier: "436366",
        sku: "0",
        MaterialCost: "214014",
        gallery: "374306",
        image: "374303",
        thumbnail: "374304",
        meta_title: "374301",
        visibility: "436364",
        isCustomized: "436367",
        media_gallery: "374305",
        tax_class_id: "436368",
        CustomProductResource: "374300",
        weight: "214008",
        meta_description: "374302",
        country_of_manufacture: "374297",
        special_price: "214010",
        meta_keyword: "1091410",
        product_seo_name: "1091409",
        video_id: "374298"
      },
      typeId: "Course",
      catalogInventoryStockItem: {
        manageStock: 1,
        itemId: 92193,
        enableQtyIncrements: 0,
        qty: 1.0,
        stockId: 1,
        isQtyDecimal: 1,
        isInStock: 1.0,
        maxQty: 0.0,
        notifyStockQty: 1.0,
        minQty: 0.0,
        stockStatusChangedAuto: 1
      },
      catalogInventoryStockStatus: {
        websiteId: 1,
        qty: 1.0,
        stockId: 1,
        stockStatus: 1
      },
      productEntityMediaGallery: [],
      catalogCategoryProduct: [
        {
          categoryId: 1187,
          position: 0,
          productId: 95824,
          minPrice: null,
          maxPrice: null
        }
      ],
      catalogProductSuperAttribute: [],
      catalogProductSuperLink: [],
      catalogProductLink: [],
      varientProductItems: [],
      variant: null,
      slots: [],
      course: [
        {
          courseId: 2,
          title: "Introduction",
          productId: 95824,
          active: 1,
          customField1: "",
          customField2: "",
          customField3: "",
          customField4: "",
          customField5: "",
          customField6: "",
          customField7: "",
          customField8: "",
          customField9: "",
          customField10: "",
          courseItem: [
            {
              courseItemId: 2,
              courseId: 2,
              title: "JavaScript Development Workbook",
              type: 0,
              active: 1,
              freePreview: "",
              view: "",
              customField1: "",
              customField2: "",
              customField3: "",
              customField4: "",
              customField5: "",
              customField6: "",
              customField7: "",
              customField8: "",
              customField9: "",
              customField10: ""
            },
            {
              courseItemId: 3,
              courseId: 2,
              title: "Variables in JavaScript",
              type: 0,
              active: 1,
              freePreview: "",
              view: "",
              customField1: "",
              customField2: "",
              customField3: "",
              customField4: "",
              customField5: "",
              customField6: "",
              customField7: "",
              customField8: "",
              customField9: "",
              customField10: ""
            }
          ]
        }
      ]
    }
  ];

  public serverPath = environment.commonImageApi + '/courseVideo/';

  public serverPath1 = environment.commonImageApi + '/courseImage/';

  public serverPath2 = environment.commonImageApi + '/courseAudio/';

  downloadPdf(name) {
    if(name!=undefined){
      let smallImage = "/coursepdf/" + name;
      this.productService.downloadPdf(smallImage).subscribe(
        data => {
          downloads(data,name);
        },
      )}
  }

  @ViewChild('videoPlayer') videoPlayer: ElementRef;
  currentVideoUrl:string;

  changeVideo(url: string, data: any) {
    this.currentVideoUrl = url;
    this.activeIndex = data;
    this.videoPlayer.nativeElement.load(); // This reloads the video element with the new source
  }
  
  onVideoEnded(): void {
    let currentIndex = this.videolist.findIndex(video => video.value === this.currentVideoUrl);
    currentIndex++;
    if (currentIndex >= this.videolist.length) {
      currentIndex = 0; // Restart from the first video if the last one ends
    }
    this.changeVideo(this.videolist[currentIndex].value, this.videolist[currentIndex].title);
  }


  RestrictionDialog() {
    console.log("here popup");
    
    let dialogRef = this.dialog.open(RestrictionComponent, {
      width: '350px',
      height:'170px',
      disableClose: false,
    });
    dialogRef.disableClose = false;
  } 

  
  back() {
    this.location.back();
  }


  NavigateQuiz(value){
    this.router.navigate([`/quiz/${value}`])
  }

   // Method to play video when it can play
   playVideo(video: HTMLVideoElement) {
    video.play();
  }

  // Method to disable right-click context menu
  disableContextMenu(event: MouseEvent) {
    event.preventDefault();
  }
  
}